(function (){
    'use strict';

    angular
        .module('services')
        .factory('CostCenter', CostCenter);

    /* @ngInject */
    function CostCenter ($http, API_BASE) {
        /* Static methods and properties */
        CostCenter.create = create;
        CostCenter.all = all;
        CostCenter.where = where;
        CostCenter.destroy = destroy;
        CostCenter.API_RESOURCE = `${API_BASE}/cost_centers`;
        CostCenter.API_OPTIONS = { header: { 'Content-Type': 'application/json; charset=UTF-8' } };

        /* Instance methods */
        CostCenter.prototype.fill = fill;
        CostCenter.prototype.save = save;
        CostCenter.prototype.update = update;

        /* Constructor */
        return CostCenter;

        /* Implementation details */ 
        function CostCenter(data) {
            this.name = null;
            this.parent_id = null;
            this.qbo_id = null;
            
            if (data !== undefined) {
                this.fill(data);
            }
        }

        function create(data) {
            let costCenter = new CostCenter(data);

            costCenter.save();

            return costCenter;
        }
        
        function save() {
            return $http.post(CostCenter.API_RESOURCE, this, CostCenter.API_OPTIONS)
                .then(res => new CostCenter(res.data));
        }

        function fill(data) {
            for (let attr in data) {
                this[attr] = data[attr]; 
            }
            return this;
        }

        function update(data) {
            this.fill(data);
            return $http.post(`${CostCenter.API_RESOURCE}/${this.id}`, this, CostCenter.API_OPTIONS)
                .then(res => new CostCenter(res.data));
        }

        function destroy(id) {
            return $http.delete(`${CostCenter.API_RESOURCE}/${id}`, { ...CostCenter.API_OPTIONS });
        }

        function all(query) {
            return $http.get(`${CostCenter.API_RESOURCE}/all`, { ...CostCenter.API_OPTIONS });
        }

        function where(query) {
            return $http.get(CostCenter.API_RESOURCE, {
                    ...CostCenter.API_OPTIONS, 
                    params: query
                });
            }
    }
})();